// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
  list-style-type: disc; 
  padding-left: 20px;
}

ol {
  list-style-type: decimal;
  padding-left: 20px;
}

li {
  margin-bottom: 5px;
  padding-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Shared/Components/BotChatBlock/BotChatBlock.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["ul {\n  list-style-type: disc; \n  padding-left: 20px;\n}\n\nol {\n  list-style-type: decimal;\n  padding-left: 20px;\n}\n\nli {\n  margin-bottom: 5px;\n  padding-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
